import styled from 'styled-components';
import { NitroTextField } from 'nitro-components';

export const tableHeaderStyles = {
  background: '#f5f5f5',
  color: '#9e9e9e',
  height: '42px'
};

export const tableRowStyles = {
  height: '42px'
};

export const tableHeaderColumnStyles = {
  textTransform: 'uppercase',
  padding: '0 24px',
  height: '42px'
};

export const tableAddressColumnStyles = {
  width: '250px'
};

export const tableActionColumnStyles = {
  ...tableHeaderColumnStyles,
  width: '125px'
};

export const UnWrappedColumn = styled.p`
  white-space: pre-wrap;
`;

export const FuelCardInput = styled(NitroTextField)`
  height: 40px;
  padding-left: 16px;
  border: 1px solid
    ${props =>
      props.error ? props.theme.color.negative : props.theme.color.border};
`;



// WEBPACK FOOTER //
// ./src/features/fuel-cards/styles.js